/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Integrations_TitleInputs */

const tr_landing_integrations_title = /** @type {(inputs: Landing_Integrations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tek panelden yönettiğiniz servisler`)
};

const en_landing_integrations_title = /** @type {(inputs: Landing_Integrations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Services you run from a single panel`)
};

const de_landing_integrations_title = /** @type {(inputs: Landing_Integrations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dienste, die Sie aus einem Panel steuern`)
};

const ru_landing_integrations_title = /** @type {(inputs: Landing_Integrations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сервисы, которыми вы управляете из одной панели`)
};

/**
* | output |
* | --- |
* | "Services you run from a single panel" |
*
* @param {Landing_Integrations_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_integrations_title = /** @type {((inputs?: Landing_Integrations_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Integrations_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_integrations_title(inputs)
	if (locale === "de") return de_landing_integrations_title(inputs)
	if (locale === "ru") return ru_landing_integrations_title(inputs)
	return tr_landing_integrations_title(inputs)
});